// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_1YMZh","smallLinkTypography":"JcqXq","titleTypography":"swrMx","cardTitleTypography":"_1bxvY","truncate":"_3vITQ","base":"_3Fgrn","noBeneficiary":"_1Wn16","sectionTopHeader":"_3qYOO","section":"_10YYp","sectionTitle":"_4lV9a","sectionContent":"_3oGe_","sectionLoading":"_221XZ","sectionFooter":"_2DkfA","linkButton":"_2O7b0","button":"_1XJvT","tip":"_3vziv","panel":"_3Ef-a","line":"_1AIcI","stepStatus":"_2BB7G","stepSymbol":"_3R_o6","stepDetails":"DT-vC","actions":"_3aygy","greenAvatar":"_137CC","greyAvatar":"_15tq5","uploadSection":"_2Yrdl","footer":"_1vSap"};


//////////////////
// WEBPACK FOOTER
// ./src/views/TemplateUpload/TemplateUpload.scss
// module id = 479
// module chunks = 0